export default __webpack_public_path__ + "static/media/analytics2.bce10925.png";